<template>
  <div class="h5login">
    <div class="container" v-if="flag === 1">
      <div class="bindPhone">手机号绑定</div>
      <div class="login">
        <p>
          <input type="text" v-model="login.phone" placeholder="请输入手机号">
        </p>
        <p>
          <input type="text" v-model="login.code" placeholder="请输入验证码">
          <span  @click="telCode" id="sentCode" >获取验证码</span>
        </p>
      </div>
        <div class="h5login_footer" @click="save"> <span>立即使用</span> </div>
    </div>
    <div v-if="flag === 0">
        <p>{{ trueCode }}</p>
    </div>
  </div>
</template>

<script defer=true>

import * as api from "@/api";
import JmmToast from '@/components/JmmToast'
export default {
  name: "wxlogin",
  data() {
    return {
       login: {
        phone:null,
        code: null,
      },
      trueCode: null,
      prohibit: true,

      flag: 0,          // 控制视图绑定的DOM

      token: "",
      unionid: "",
      userid: "",
      openid:"",
      mobile:"",

      appid: "wxc528cd4698883637",
      MT_appid: 'wxfb731459c16602bc',
      sign: null,  // 签名
      return_uri: '',    // 银行业务绑定成功后跳转 地址
      merchantId: '',
      stateId: ''
    };
     
  },


  created() {
    this.merchantId = this.$route.query.merchantId;
    this.stateId = this.$route.query.state;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    } else if(null != this.stateId && undefined != this.stateId && "merchantId" != this.stateId){
      this.merchantId = this.stateId;
      localStorage.setItem('cityMerchantId', this.merchantId);
    } else {
      localStorage.setItem('cityMerchantId', "");
    }
    // this.unionid = this.$route.query.unionid;
    // this.cardrights = this.$route.query.cardrights;
    // this.merchantid = this.$route.query.merchantid;


    this.token = this.$route.query.token;

    this.return_uri = this.$route.query.return_uri
    // alert(this.return_uri, this.token)
  },

  mounted() {
    this.getCode()
  },

  methods: {
    telCode: async function () {
      let rgh = /^[1]([3-9])[0-9]{9}$/
      if (!rgh.test(this.login.phone)) {
        return JmmToast('手机号码有误')
      }

      //防重点击
      if (!this.prohibit) {
        console.log('正在获取中，请勿重复')
        return
      }

      var i = 61
      let that = this
      let intervalID = setInterval(function() {
          i -= 1
          document.getElementById('sentCode').innerHTML = i + ' s'
          if (i == -1) {
            that.prohibit = true
            // console.log(i,'-------------', that.prohibit)
            clearInterval(intervalID)
            document.getElementById('sentCode').innerHTML = '重新获取'
            return
          }
      }, 1000)

       this.prohibit = false

      try {
        
        // let testToken = '123'
        let testToken = 'jjcimpilpgejfeehkdinjlbgabbgchhe'
        // let MT_token = 'jhefijjnecechlkmbiodlfbpjdcpnplc'

        let canToken = this.token === testToken ? testToken : MT_token
        localStorage.setItem('reToken', canToken)
        // localStorage.setItem('reToken', testToken)
         const res = await api.user.getMsg(this.login.phone)
         if (res.code === '000000') {
           console.log(res.message, 'res')
         }
      } catch (error) {
       console.log(error)
      }
      
    },
    save: async function() {
        if (!this.login.phone) {
          return JmmToast('手机号不能为空')
        }
        
        let rgh = /^[1]([3-9])[0-9]{9}$/
        if (!rgh.test(this.login.phone)) {
          return JmmToast('手机号码有误')
        }

        if (!this.login.code) {
          return JmmToast('验证码不能为空')
        }

        // if (this.login.code !== this.telCode) {
        //   return JmmToast('验证码不正确')
        // }

        try {
        //   let testToken = '123'
          let testToken = 'jjcimpilpgejfeehkdinjlbgabbgchhe'
        //   let MT_token = 'jhefijjnecechlkmbiodlfbpjdcpnplc'
          let canToken = this.token == testToken ? testToken : MT_token
        //   localStorage.setItem('reToken', testToken)
          localStorage.setItem('reToken', canToken)
          let params = {
            "code": this.login.code,
            "mobile": this.login.phone,
            "sign": this.sign
          }
          const res = await api.user.bindPhone(params)
          if (res.code == '000000') {
            //   window.location.href = 'https://' + this.return_uri + `?userid=${this.userid}&openid=${this.openid}&sign=${this.sign}&unoinid=${this.unionid}&phone=${this.mobile}`
            let Bank_url = this.return_uri + `?userid=${this.userid}&openid=${this.openid}&sign=${this.sign}&unoinid=${this.unionid}&phone=${this.mobile}`
            
            // let meiTuan_url = `http://account.kangou.cn/activitycardloginList.html#/?userid=${this.userid}&openid=${this.openid}&sign=${this.sign}&unoinid=${this.unionid}&phone=${this.mobile}`
            let meiTuan_url = `http://www.baidu.com/?userid=${this.userid}&openid=${this.openid}&sign=${this.sign}&unoinid=${this.unionid}&phone=${this.mobile}`
            
            var goUrl = this.token == testToken ? Bank_url : meiTuan_url
           
            window.location.href = goUrl
    //         用户唯一标识：ucenter_user_id（必传）
    // 微信unionid： unionid（必传）
    // 用户手机号：  mobile（必传）
    // 用户昵称：nickname （可选。有的话，最好传一下）
    // 登陆卡包的类型：login_cardtype（必传。如果用户没有登陆卡，那这个参数传0即可）

            alert(res+'查看美团返回参数')
          }
        } catch (error) {
          console.log(error)
        }
    },
  getCode(){ // 1 非静默授权，第一次有弹框
    
    this.code = ''
    var local = window.location.href // 获取页面url
    if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
      // 获取授权后的code位置
      var codeBeg = local.indexOf("?code=");
      var codeEnd = local.indexOf("#/?");
      // 截取授权后的code数据
      var codeCut = local.substring(codeBeg, codeEnd);
      local = local.replace(codeCut, "");
    }
    // var appid = this.MT_appid
    var appid = this.appid
    //  let testToken = '123'
     let testToken = 'jjcimpilpgejfeehkdinjlbgabbgchhe'
    // let MT_token = 'jhefijjnecechlkmbiodlfbpjdcpnplc'
    // let canToken = this.token === testToken ? testToken : MT_token
    // var appid = this.token == testToken ? this.appid : this.MT_appid
    this.code = this.getUrlCode().code // 截取code
    if (this.code == null || this.code === '') { // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=${this.merchantId}#wechat_redirect`
    } else {
      var merchantIdState = this.getUrlCode().state // 截取state
      if(null == merchantIdState || undefined == merchantIdState){
        merchantIdState = '';
      }
      if('' == this.merchantId && '' != merchantIdState){
        this.merchantId = merchantIdState;
        localStorage.setItem('cityMerchantId', this.merchantId);
      }
      // 通过code获取信息 
      this.trueCode = this.code
      // this.fetch(this.code)
    }
  },

  getUrlCode() { // 截取url中的code方法
    var url = location.search
    this.winUrl = url
    var theRequest = new Object()
    if (url.indexOf("?") != -1) {
        var str = url.substr(1)
        var strs = str.split("&")
        for(var i = 0; i < strs.length; i ++) {
            theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
        }
      }
      return theRequest
  },
  
    //  code 登录
    async fetch(codeNum) {
      let _this = this
      try {
        // let testToken = '123'
        let testToken = 'jjcimpilpgejfeehkdinjlbgabbgchhe'
        // let MT_token = 'jhefijjnecechlkmbiodlfbpjdcpnplc'
        let canToken = this.token === testToken ? testToken : MT_token
        let info = {
        //   "appId": this.MT_appid,
        //   "appId": this.appid,
          "appId": this.token == testToken ? this.appid : this.appid,
          "wxcode": codeNum
        }
        //  localStorage.setItem('reToken', MT_token)
         localStorage.setItem('reToken', canToken)
           
          const res = await api.user.webLogin(info)
         alert(JSON.stringify(res) +'查看美团返回参数' + JSON.stringify(info)+'请求头'+JSON.stringify(localStorage.getItem('reToken')))
          if (res.code == "000000") { 
            this.sign = res.data.sign
            if (!res.data.mobile) {
              this.flag = 1
              return
            } else {
              this.flag = 0   // 电话号码不为空,则不显示视图
              
              this.userid = res.data.userid
              this.openid = res.data.openid
              this.sign = res.data.sign
              this.unionid = res.data.unionid
              this.mobile = res.data.mobile

            //    window.location.href = 'https://' + this.return_uri + `?userid=${res.data.userid}&openid=${res.data.openid}&sign=${res.data.sign}&unoinid=${res.data.unionid}&phone=${res.data.mobile}`

               let Bank_url = this.return_uri + `?userid=${res.data.userid}&openid=${res.data.openid}&sign=${res.data.sign}&unoinid=${res.data.unionid}&phone=${res.data.mobile}`

             let meiTuan_url = `http://www.baidu.com/?userid=${res.data.userid}&openid=${res.data.openid}&sign=${res.data.sign}&unoinid=${res.data.unionid}&phone=${res.data.mobile}`

            //  let meiTuan_url = `http://account.kangou.cn/activitycardloginList.html#/?userid=${res.data.userid}&openid=${res.data.openid}&sign=${res.data.sign}&unoinid=${res.data.unionid}&phone=${res.data.mobile}`
            
            window.location.href = this.token == testToken ? Bank_url : meiTuan_url

            }
          } else{
            if (res.code == '40163' || res.code == '40029') {
              var local = window.location.href // 获取页面url
              if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
                // 获取授权后的code位置
                var codeBeg = local.indexOf("?code=");
                var codeEnd = local.indexOf("#/?");
                // 截取授权后的code数据
                var codeCut = local.substring(codeBeg, codeEnd);
                local = local.replace(codeCut, "");
              }
              // 重新访问 此路径地址
              window.location.href = local;
            }
          }
      } catch (err) {
        //JmmToast(err);
        console.log(err)
      }
    },

  },
}
</script>

<style lang="stylus">
@import '../../assets/css/common.styl';
@import '../../assets/css/icon.css';
@import '../../assets/css/stylesheet.css';

.h5login {
  width: 100%;
  height: 100vh;
  overflow: auto;
  background: #fff;

   display: flex;
  justify-content: center;
  align-items: center;
}

.container {
  width: 621px;
  margin: 0px auto; 
}
.login {
  margin: 0px auto; 
  margin: 200px auto; 
  p:first-child {
    border-top: 1px solid #d7d7d7;
    display: flex;
    align-items: center;
    justify-content: flex-start;  
  }
  p:nth-child(2) {
    display: flex;
    justify-content: space-between;
    align-items: center; 
  }
  p {
    border-bottom: 1px solid #d7d7d7;
    height: 120px;
    line-height :120px;
    input {
      border: none;
			outline: none;
			resize: none;
      height: 70px;

      font-size: 30px;
      font-family: Source Han Sans SC VF;
      font-weight: 400;
      line-height: 44px;
      color: #8A8A8A;
    }

    input::-ms-input-placeholder{ color: #8A8A8A; }
    input::-webkit-input-placeholder {color: #8A8A8A; } 
    span {
      opacity: 1 !important; 
      display: inline-block;
      width: 245px;
      height: 70px;
      background: #FC4E4D;
      border-radius: 35px;

      font-size: 28px;
      font-family: Source Han Sans SC VF;
      font-weight: 400;
      line-height: 70px;
      text-align: center;
      color: #FFFFFF;
    }
  }
}

.bindPhone {
  font-size: 56px;
  font-family: Source Han Sans SC VF;
  font-weight: bold;
  color: #515151;
}

.h5login_footer {
    width: 100%;
    height: 100px;
    background: #FC4E4D;
    border-radius: 50px;

    font-size: 32px;
    font-family: Source Han Sans SC VF;
    font-weight: 400;
    color: #FFFFFF;

    text-align: center;
    line-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/view/qrcodecardlist/index.vue